export default {
  copyright: '© {{startYear}} – {{lastYear}} - Society 54',
  sameYearCopyright: '© {{year}} – Society 54',
  profileEdit: 'Edit profile',
  signOut: 'Sign out',
};
